/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DomainValueDto } from '../models/domain-value-dto';
import { DynamicCriteriaDto } from '../models/dynamic-criteria-dto';


/**
 * Valores de dominio
 */
@Injectable({
  providedIn: 'root',
})
export class DomainValuesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getDomainValues
   */
  static readonly GetDomainValuesPath = '/domain-values/{domain}';

  /**
   * Listar valores do dominio.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDomainValues()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDomainValues$Response(params: {
    domain: string;
    criteria: DynamicCriteriaDto;
  }): Observable<StrictHttpResponse<Array<DomainValueDto>>> {

    const rb = new RequestBuilder(this.rootUrl, DomainValuesService.GetDomainValuesPath, 'get');
    if (params) {
      rb.path('domain', params.domain, {});
      rb.query('criteria', params.criteria, {"style":"deepObject","explode":true});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DomainValueDto>>;
      })
    );
  }

  /**
   * Listar valores do dominio.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getDomainValues$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDomainValues(params: {
    domain: string;
    criteria: DynamicCriteriaDto;
  }): Observable<Array<DomainValueDto>> {

    return this.getDomainValues$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DomainValueDto>>) => r.body as Array<DomainValueDto>)
    );
  }

}
